module.exports = __webpack_public_path__ + "static/media/OKButton_72dpi.4ffd36c2.png";